module.exports = __webpack_public_path__ + "img/200116.cdb96428.png";